import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../Auth";
import {
  isChrome,
  isChromium,
  isEdge,
  isOpera,
  isYandex,
  isMobileSafari,
  isSafari,
} from "react-device-detect";
import "./style.scss";

const Drawer = (props) => {
  const [height, setHeight] = useState(0);
  const authContext = useContext(AuthContext);
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions());
    return () => {
      window.removeEventListener("resize", this.updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setHeight(window.innerHeight);
  };

  let drawerClasses = "side-drawer";
  if (props.show) {
    drawerClasses = "side-drawer open";
  }
  return (
    <>
      {!(
        isChrome ||
        isChromium ||
        isEdge ||
        isOpera ||
        isYandex ||
        isMobileSafari ||
        isSafari
      ) ? (
        <div
          class={props.show ? "background-image show" : "background-image"}
        ></div>
      ) : (
        ""
      )}
      <div
        className={drawerClasses}
        style={
          props.backdrop
            ? { backdropFilter: "blur(50px)" }
            : {
                backgroundImage: `url(${require("../../assets/images/background.png")})`,
              }
        }
      >
        <img
          alt="close"
          className="navbar-closebtn"
          src={require("./../../assets/images/closebtn.svg")}
          onClick={props.handleClickClose}
        ></img>
        <img
          alt="logo"
          src={require("./../../assets/images/logo.svg")}
          className="navbar-logo"
        ></img>
        <ul className="navbar-list">
          <Link className="navbar-list-link" to="/about">
            <li onClick={props.handleClickClose}>How to play?</li>
          </Link>
          <Link className="navbar-list-link" to="/chart">
            <li onClick={props.handleClickClose}>Scores</li>
          </Link>
          <Link className="navbar-list-link" to={"/profile"}>
            <li onClick={props.handleClickClose}>My Profile</li>
          </Link>
          <Link className="navbar-list-link" to={"/profile/edit"}>
            <li onClick={props.handleClickClose}>Edit Profile</li>
          </Link>
          {authContext.currentUser ? (
            <li className="navbar-list-link" onClick={props.handleClickSignOut}>
              Sign Out
            </li>
          ) : (
            <li className="navbar-list-link" onClick={props.handleClickSignIn}>
              Sign In
            </li>
          )}
        </ul>
        <span className="navbar-split"></span>
        <span className="navbar-split1"></span>
        <span className="navbar-split2"></span>
        <span className="navbar-split3"></span>
        <span className="navbar-split4"></span>
        <span className="navbar-split5"></span>
        <div
          className="footer"
          style={{ marginTop: height - 40, textAlign: "center" }}
        >
          ©2018 lucky7.game
        </div>
      </div>
    </>
  );
};
export default Drawer;
